const en: any = {
  'delete': 'Delete',
  'UUID': 'UUID',
  'all': 'All',
  'button': {
    'cancel': 'Cancel',
    'add': 'Add',
    'register': 'Register',
    'save': 'Save',
    'edit': 'Edit',
    'delete': 'Delete',
    'login': 'Login',
    'logout': 'Logout',
    'setting_suru': 'Setting',
    'search': 'Search',
    'select': 'Select',
    'export_csv': 'CSV Export',
    'import_csv': 'CSV Import',
  },
  'breadcrumb': {
    'operator_info_manage': 'Manage operators',
    'unit_info_manage': 'Manage units',
    'unit_detail': 'Unit Details',
    'news_info_manage': 'Manage news',
    'question_info_manage': 'Manage FAQs',
    'unit_floors': 'Manage Floors',
    'unit_beacons': 'Manage Beacons',
    'unit_cards': 'Manage Cards',
    'unit_users': 'Manage Users',
  },
  'label': {
    'search_placeholder': 'Search...',
    'unit_name': 'Unit name',
    'customer_name': 'Customer name',
    'address': 'Address',
    'domains': 'Domains',
    'api_keys': 'Api Keys',
    'token': 'Token',
    'db_name': 'Database name',
    'timezone': 'Timezone',
    'yes': 'Yes',
    'no': 'No',
    'operator_name': 'Operator name',
    'unit': 'Unit',
    'numof_operators': '# of operators',
    'access_right': 'Access right',
    'title': 'Title',
    'url': 'URL',
    'type': 'Type',
    'content': 'Content',
    'password': 'Password',
    'search_unit_info': 'Search Unit',
    'logo': 'Logo',
    'detail': 'Details',
    'updated_at': 'Updated',
    'threshold': 'WR Paring Threshold',
    'manage_features': 'Manage Features',
    'features': 'Features',
    'status': 'Enabled',
    'status_title': 'Status',
    'stamp_rally': 'Stamp Rally',
    'work_recorder': 'Charts',
    'ip_camera': 'IP Camera',
    'geofence': 'Geofence',
    'floor_name': 'Floor Name',
    'floor_id': 'Floor ID',
    'building_name': 'Building Name',
    'floor': 'Floor',
    'floor_file': 'Floor map',
    'lon': 'Lon',
    'lat': 'Lat',
    'camera': 'Camera',
    'beacon_uuid': 'Beacon UUID',
    'possition': 'Position',
    'san_id': 'Card ID',
    'user_id': 'User ID',
    'username': 'Name',
    'category': 'Category',
    'category_name': 'Category name',
    'people': 'People',
    'things': 'Things',
    'major': 'Major',
    'minor': 'Minor',
    'card_number': 'Card Number',
    'mobile_username': 'Mobile username',
    'static': 'Static',
    'carried': 'Carried',
    'confirm_delete': 'Delete Confirm',
    'location': 'Location',
    'stat': 'Stats',
    'ip_whitelist': 'IP Whitelist',
    'ip_address': 'IP Address',
    'feature': 'Feature',
    'width': 'Width',
    'height': 'Height',
    'order': 'Order',
    'full': 'Full',
    'user_type': 'User Type',
    'filter_text': 'Filter Text',
    'all': 'All Types',
    'name': 'Name',
    'indoor_map': 'Indoor Map',
    'outdoor_map': 'Outdoor Map',
    'link': 'Link',
  },
  'option': {
    'type': {
      'info': 'Info',
      'important': 'Important',
    },
    'access_right': {
      'owner': 'Owner',
      'manager': 'Manager',
      'observer': 'Observer',
    },
    'api_key_access_right': {
      'owner': 'Owner',
      'admin': 'Admin',
      'viewer': 'Viewer',
    },
  },
  'menu': {
    'dashboard': 'DashBoard',
    'system_menu': 'System Menu',
    'manage_unit': 'Manage Category',
    'manage_operator': 'Manage Cards',
    'manage_news': 'Manage Beacons',
    'manage_questions': 'Manage Floors',
    'unit': 'Units',
    'operator': 'Operators',
    'news': 'News',
    'question': 'FAQs',
    'information': 'Information',
    'floor': 'Floors',
    'card': 'Cards',
    'user': 'Users',
    'beacon': 'Beacons',
    'tracking_data': 'Tracking Data',
    'widget_setting': 'Widget Setting'
  },
  'messages': {
    'data_not_found': 'Date not found!',
    'username_required': 'Username is required.',
    'password_required': 'Password is required.',
    'are_you_sure_want_to_delete': 'Are you sure to delete this item?',
    'has_refs_data_are_you_sure_want_to_delete': 'This item have related information. Continue to delete it?',
    'drop_file_here_or_select_a_file': 'Drop a file here or select a file.',
    'save_success': 'Data stored successfully.',
    'update_success': 'Data updated successfully.',
    'delete_success': 'Data deleted successfully.',
    'field_is_required': 'This field is required.',
    'ask_for_delete': 'Do you really want to delete these fields?',
    'can_dnd_order': 'You can switch order item by drag row into another row',
    're_order_success': 'Moved order {from} to order {to}'
  },
  'content': {
    'first_ex_location': 'The signal data emitted from beacons, taken from the JBOX server',
    'second_ex_location': 'This data affects the tracking data of the whole unit',
    'first_ex_stats': 'The data generated by the calculation from the location collection',
    'second_ex_stats': 'This data is used in the work-recorder screen',
  },
  'pagination': {
    'per_page': 'per page',
    'of_pages': 'of page(s)',
  },
  'widget_setting': {
    'user_search': 'User Search',
    'indoor': 'Indoor Map',
    'outdoor': 'Outdoor Map'
  },
  'placeholder': {
    'input_filter': 'Enter text to filter',
    'input_order': 'Enter ordinal number'
  }
}

export default en
